/**
 * GiftDashboardPresenter
 * --
 */
import React from 'react';
import {
  Content,
  Title,
  Row,
  Col,
  ExpandableContainer,
  Table,
  Statistic,
} from 'components';
import { Avatar, Button, DatePicker, Input, Select } from 'antd';
import { PictureOutlined } from '@ant-design/icons';
import { stringToMoneyFormat } from 'utils';

const GiftDashboardPresenter = () => {
  /* ===== ROUTE ===== */
  /* ===== PROPS ===== */
  /* ===== STATE ===== */
  /* ===== VARIABLE ===== */
  const styles = {
    title: {
      fontSize: 24,
      fontWeight: 700,
      marginBottom: 20,
    },
    button: {
      width: 80,
      height: 40,
      fontSize: 15,
      fontWeight: 600,
      margin: '0px 4px',
    },
    form: {
      input: {
        large: {
          width: 175,
          marginRight: 8,
        },
        medium: {
          width: 100,
          marginRight: 8,
        },
      },
      button: {
        marginRight: 8,
      },
      date: {
        width: 120,
      },
      text: {
        fontSize: 13,
        fontWeight: 400,
      },
    },
  };

  const formItem = [
    {
      label: '선물 카테고리',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '상품 카테고리',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
      ],
    },
    {
      label: '구매기간',
      form: [
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              오늘
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1주일
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              1개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              3개월
            </Button>
          ),
        },
        {
          input: (
            <Button size="large" style={{ ...styles.form.button }}>
              전체
            </Button>
          ),
        },
        {
          input: (
            <>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
              <p style={{ ...styles.form.text, padding: '0px 2px' }}>~</p>
              <DatePicker
                size="large"
                format={'YYYY-MM-DD'}
                placeholder=""
                style={{ ...styles.form.date }}
              />
            </>
          ),
        },
      ],
    },
    {
      label: '입점 업체',
      form: [
        {
          input: (
            <Select
              size="large"
              value={'전체'}
              options={[{ label: '전체', value: '전체' }]}
              style={{ ...styles.form.input.large }}
            />
          ),
        },
        {
          input: (
            <>
              <Input
                size="large"
                placeholder="검색어를 입력해주세요"
                style={{ ...styles.form.input.large }}
              />
            </>
          ),
        },
      ],
    },
  ];

  // NOTE: 테이블 가짜 데이터
  let newData = [];
  // for (let i = 0; i < 10; i++) {
  //   newData.push({
  //     no: i + 1,
  //     상품구분: '기본상품',
  //     상품코드: `0000000`,
  //     img: <Avatar size={50} shape="square" icon={<PictureOutlined />} />,
  //     name: '[과테말라] 디카페인 200g',
  //     price: 20000,
  //     sale: 500,
  //     m_sale: 1000,
  //     url: `URL`,
  //   });
  // }

  /* ===== FUNCTION ===== */
  /* ===== HOOKS ===== */
  /* ===== RENDER ===== */
  return (
    <Content maxWidth={'100%'} padding={20} backgroundColor={'none'}>
      <Row>
        <Col x={24}>
          <Title style={{ ...styles.title }}>대시보드</Title>

          {/* 요약 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40, display: 'flex' }}
          >
            {[
              { title: '전체 등록 상품', value: 0, suffix: '개' },
              { title: '판매 중인 상품', value: 0, suffix: '개' },
              { title: '품절 상품', value: 0, suffix: '개' },
            ].map((_item, _index) => (
              <div
                key={`${_item.label}-${_index}`}
                style={{
                  background: '#FFFFFF',
                  borderRadius: 4,
                  width: `calc(100% / 3)`,
                  marginRight: _index === 2 ? 0 : 4,
                  padding: 20,
                }}
              >
                <Statistic
                  title={_item.title}
                  value={_item.value}
                  suffix={_item.suffix}
                  direction={'row'}
                  style={{ justifyContent: 'center' }}
                />
              </div>
            ))}
          </Content>
          {/* 요약 끝 */}

          {/* 검색필터 */}
          <Content
            maxWidth={'100%'}
            padding={0}
            backgroundColor={'none'}
            style={{ marginBottom: 40 }}
          >
            <ExpandableContainer borderRadius={4} padding={20}>
              {formItem.map((_item, _index) => (
                <div
                  key={`form_${_index}`}
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    padding: '10px 0px',
                  }}
                >
                  <div style={{ width: 120, fontSize: 13, fontWeight: 400 }}>
                    <label>{_item.label}</label>
                  </div>
                  <div style={{ display: 'flex', alignItems: 'center' }}>
                    {_item.form.map((_subitem, _subkey) => (
                      <React.Fragment key={`input_${_subkey}`}>
                        {_subitem.input}
                      </React.Fragment>
                    ))}
                  </div>
                </div>
              ))}
            </ExpandableContainer>

            {/* 검색/초기화 버튼 */}
            <div
              style={{
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                width: '100%',
                marginTop: 48,
              }}
            >
              <Button
                size="large"
                type="primary"
                style={{ ...styles.button, background: 'var(--primary-color)' }}
              >
                검색
              </Button>
              <Button size="large" style={{ ...styles.button }}>
                초기화
              </Button>
            </div>
            {/* 검색/초기화 버튼 끝 */}
          </Content>
          {/* 검색필터 끝 */}

          {/* 검색결과 */}
          <Content maxWidth={'100%'} borderRadius={4} padding={20}>
            <h4 style={{ fontSize: 14, fontWeight: 500, marginBottom: 12 }}>
              검색 결과 총 <span>0</span>건
            </h4>
            <Table
              data={newData}
              isChecked
              columns={[
                {
                  title: 'No',
                  key: 'no',
                },
                {
                  title: '상품구분',
                  key: '상품구분',
                },
                {
                  title: '상품코드',
                  key: '상품코드',
                },
                {
                  title: '상품 이미지',
                  key: 'img',
                },
                {
                  title: '상품명',
                  key: 'name',
                },
                {
                  title: '판매가',
                  key: 'price',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: '할인가',
                  key: 'sale',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: '모바일 할인가',
                  key: 'm_sale',
                  render: (item) => stringToMoneyFormat(item),
                },
                {
                  title: 'URL',
                  key: 'url',
                },
              ]}
            />
          </Content>
          {/* 검색결과 끝 */}
        </Col>
      </Row>
    </Content>
  );
};

export default GiftDashboardPresenter;
